<script lang="ts" setup>
type Props = {
  phones: string[]
}

const props = defineProps<Props>()

const formattedPhones = props.phones.map((phone) => {
  return {
    number: phone,
    href: phone.replaceAll(' ', ''),
  }
})
</script>

<template>
  <div class="header-phones">
    <a
      v-for="(phone, index) in formattedPhones"
      :key="index"
      class="header-phones__link"
      :href="`tel:${phone.href}`"
    >
      {{ phone.number }}
    </a>
  </div>
</template>

<style lang="scss" scoped>
.header-phones {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &__link {
    display: block;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: var(--ui-text-primary);

    @include media('>=desktop') {
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
